import { formatCurrencyValue } from '@vend/utilities'
import React from 'react'
import {
  useRegisterManager,
  useRetailerSettingsManager,
} from '../../../ng-compat/hooks'

interface Props {
  total: number | string
}

export const Total: React.FC<Props> = ({ total }) => {
  const currentOutlet = useRegisterManager().getActiveOutlet()
  const retailer = useRetailerSettingsManager().get()

  return (
    <>
      <div>Total</div>
      <div className="sale-total-line-item--value">
        {formatCurrencyValue(
          total,
          retailer.culture,
          currentOutlet.currency,
          currentOutlet.currency_symbol
        )}
      </div>
    </>
  )
}
